import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { Grid } from "@mui/material";
import { AutocompleteField, Card, DateField } from "@curves/ui-base";
import usePeopleApi from "@apis/usePeopleApi";
import { PEOPLE_TYPE } from "@icoach/constants/";
import { getErrorModuleStatus, refIsRequiredError } from "@util/utils";

const ConsumerSection = forwardRef(({ initialSource = {}, onMemberChange, errorModule }, ref) => {
	const { people: peopleOption = [] } = usePeopleApi(PEOPLE_TYPE.ALLMEMBER);

	const memberRef = useRef(null);

	const getResult = () => {
		let result = {};

		if (memberRef.current && memberRef.current.getResult) {
			const { id } = memberRef.current.getResult();
			result.memberID = id;
		}

		return result;
	};

	useImperativeHandle(
		ref,
		() => ({
			getResult,
			isError: () => refIsRequiredError(memberRef),
		}),
		// eslint-disable-next-line
		[],
	);

	return (
		<>
			<Card.CardHeader title="訂購人資訊" className="bg-light-active px-4" />
			<Card.CardContent className={"p-4"}>
				<Grid spacing={3} container>
					<Grid xs={4} item>
						<AutocompleteField
							label="訂購人"
							ref={memberRef}
							key={`${initialSource?.memberID}_${peopleOption.length}`}
							defaultValue={initialSource?.memberID ?? 0}
							options={peopleOption}
							optionKeys={["name", "nickName", "mobile", "no"]}
							optionMaskKeys={["maskName", "nickName", "maskMobile", "no"]}
							primaryKey={"id"}
							inputProps={{
								placeholder: "請輸入會員姓名/手機/會編(擇一即可)",
							}}
							onChange={onMemberChange}
							{...getErrorModuleStatus(errorModule, "memberID")}
							fullWidth
							required
						/>
					</Grid>
					<Grid xs={4} item>
						<DateField label="生日" key={initialSource?.birthday} defaultValue={initialSource?.birthday} fullWidth disabled />
					</Grid>
				</Grid>
			</Card.CardContent>
		</>
	);
});

export default ConsumerSection;
